import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { secondary300 } from 'themes/colors';


export default function Calendar(props) {
  return (
    <SvgIcon {...props}>
      <path
        fill={secondary300}
        d="M15.667 7.333H2.333v-2.5c0-.46.373-.833.834-.833h1.666v.833a.833.833
          0 0 0 1.667 0V4h5v.833a.833.833 0 0 0 1.667
          0V4h1.666c.46 0 .834.373.834.833zm0
          7.5c0 .46-.373.834-.834.834H3.167a.833.833 0 0
          1-.834-.834V9h13.334zm-.834-12.5h-1.666V1.5a.833.833
          0 0 0-1.667 0v.833h-5V1.5a.833.833 0 0 0-1.667 0v.833H3.167a2.5 2.5
          0 0 0-2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h11.666a2.5
          2.5 0 0 0 2.5-2.5v-10a2.5 2.5 0 0 0-2.5-2.5z"
      />
    </SvgIcon>
  );
}
